import { Lock } from 'lucide-react'
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip'
import { cn } from '@/lib/utils'

/**
 * Small circular lock indicator shown on locked feature entry points. Icon
 * only (no text) so it can sit at the edge of a button/menu item without
 * covering the label — the tooltip carries the explanation instead.
 */
export default function LockBadge({
  className,
  tooltip = 'Feature is not available in your subscription',
}: {
  className?: string
  /** Pass null to render the icon without a tooltip. */
  tooltip?: string | null
}) {
  const icon = (
    <span
      className={cn(
        'inline-flex size-4 shrink-0 items-center justify-center rounded-full bg-purple-default text-white',
        className,
      )}
    >
      <Lock className="size-2.5" />
    </span>
  )

  if (!tooltip) return icon

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>{icon}</TooltipTrigger>
        <TooltipContent>{tooltip}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  )
}
